import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

// Helper to get the token from Redux or storage
const getAuthToken = (getState) =>
  (getState && getState().auth && getState().auth.token) ||
  sessionStorage.getItem("access_token") ||
  localStorage.getItem("access_token");

export const fetchLatestBloodPressure = createAsyncThunk(
  "bloodPressure/fetchLatest",
  async (patientId, { rejectWithValue, getState }) => {
    try {
      const token = getAuthToken(getState);
      const response = await axios.get(
        `${API_URL}/vitals/patient/${patientId}/blood_pressure/latest`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue("Failed to fetch blood pressure data");
    }
  }
);

const bloodPressureSlice = createSlice({
  name: "bloodPressure",
  initialState: { data: null, loading: false, error: null },
  reducers: {
    clearBloodPressure(state) {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLatestBloodPressure.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLatestBloodPressure.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchLatestBloodPressure.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export const { clearBloodPressure } = bloodPressureSlice.actions;
export const selectBloodPressure = (state) => state.bloodPressure;
export default bloodPressureSlice.reducer;